import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer id="footer" className="bg-[#0A5E5C] text-white pt-20 pb-10" data-id="element-51">
      <div className="container mx-auto px-4" data-id="element-52">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-53">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-54">
            <div className="flex items-center gap-2 mb-6" data-id="element-55">
              <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center" data-id="element-56">
                <span className="text-[#D4A843] font-serif font-bold text-lg" data-id="element-57">
                  FG
                </span>
              </div>
              <span className="text-xl font-serif font-bold" data-id="element-58">
                Fair Gaming Space
              </span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-59">
              Ми захищаємо права гравців та сприяємо розвитку чесного ігрового
              ринку в Україні. Приєднуйтесь до нашої спільноти.
            </p>
            <div className="flex gap-4" data-id="element-60">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-61">
                <Facebook size={18} data-id="element-62" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-63">
                <Twitter size={18} data-id="element-64" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-65">
                <Instagram size={18} data-id="element-66" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-67">
                <Linkedin size={18} data-id="element-68" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-69">
            <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-70">
              Швидкі посилання
            </h3>
            <ul className="space-y-3" data-id="element-71">
              {['Головна', 'Про нас', 'Активності', 'Новини', 'Контакти'].map(item => <li key={item} data-id="element-72">
                    <a href="#" className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-73">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-74" />
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-75">
            <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-76">
              Інформація
            </h3>
            <ul className="space-y-3" data-id="element-77">
              {['Політика конфіденційності', 'Умови використання', 'Звітність', 'Для преси', 'Вакансії'].map(item => <li key={item} data-id="element-78">
                  <a href="#" className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-79">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-80" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-81">
            <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-82">
              Контактна інформація
            </h3>
            <ul className="space-y-4" data-id="element-83">
              <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-84">
                <Mail size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-85" />
                <span data-id="element-86">fgsukraine@gmail.com</span>
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-87">
                <Phone size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-88" />
                <span data-id="element-89">+38 (067) 403 2026</span>
              </li>
              
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50" data-id="element-90">
          <p data-id="element-91">© 2024 Простір Чесної Гри. Всі права захищені.</p>
          <p data-id="element-92">Розроблено з любов'ю до чесної гри</p>
        </div>
      </div>
    </footer>;
}